import { createTripArrayFieldMachine } from './createTripArrayFieldMachine';

export const pickupPhoneMachine = createTripArrayFieldMachine('pickupPhone');
